import { render, staticRenderFns } from "./cdrs.vue?vue&type=template&id=401fc44d&"
import script from "./cdrs.vue?vue&type=script&lang=js&"
export * from "./cdrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports